import Crud from '../components/Document/Crud'
import Document from '../components/Document/Document'

let routes = {
    path: '/documents',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/documents',
            name: 'Documentos',
            component: Crud
        },
        {
            path: '/document/:id?',
            name: 'Documento',
            component: Document
        },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/documents.js